import styled from "styled-components";

export const ButtonSecundary = styled.button`
padding: 8px 16px;
background-color: transparent;
color: #666;
border: none;
border-radius: 4px;
cursor: pointer;
&:hover {
  background-color: #f5f5f5;
}
`;